<!-- ----------------------------------------------- -->
<template>
  <v-card
    id="rp-dialog"
    class="com-mb-dialog normal"
    :class="[
      {
        small: editLocationMode === 1 || editTmMode === 1 || editTmMode === 2,
      },
      { large: isFull },
      { normal: !isFull },
    ]"
  >
    <v-row class="com-mb-dialog-header">
      <span class="com-mb-dialog-title rw-title">{{ text.title }}</span>
      <v-spacer></v-spacer>
    </v-row>

    <!-- 地点登録 -->
    <v-col
      v-if="content === 'VcPoint'"
      class="com-mb-dialog-contents ma-0 pa-0"
    >
      <v-col class="com-mb-dialog-frame ma-0 pa-0">
        <rp-point></rp-point>
      </v-col>
    </v-col>
    <!-- 地点登録ダイアログ -->
    <v-col
      v-if="
        editLocationMode === 1 ||
          editLocationMode === 2 ||
          editTmMode === 1 ||
          editTmMode === 2
      "
      class="rp-dialog-content"
    >
      <v-card class="ma-2 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="rp-dialog-box pl-4 pr-2 my-2">
          <v-label v-if="editLocationMode === 1">{{
            text.selectPointMsg
          }}</v-label>
          <div
            v-if="editLocationMode === 2 && towns && isRegistTown()"
            class="rp-radio-box"
          >
            <v-label>{{ text.confirmPointMsg }}</v-label>
            <v-radio-group v-model="twnCd" class="ml-2">
              <v-radio
                v-for="town in towns"
                :key="town.twnCd"
                :label="town.prefNm + town.twnNm"
                :value="town.twnCd"
              ></v-radio>
              <v-radio
                v-for="townAdd in townsAdd"
                :key="townAdd.twnCd"
                :label="townAdd.prefNm + townAdd.twnNm"
                :value="townAdd.twnCd"
              ></v-radio>
            </v-radio-group>
          </div>
          <div v-if="editLocationMode === 2 && towns && !isRegistTown()">
            <v-label>{{ text.registErrMsg }}</v-label>
          </div>

          <v-label v-if="editTmMode === 1">{{ text.selectObMsg }}</v-label>
          <v-label v-if="editTmMode === 2">{{ text.confirmObMsg }}</v-label>
        </div>
        <div
          v-if="registCurrentLocationErrorFlag && editLocationMode === 1"
          class="get-location-error-message pl-4"
        >
          {{ messageConfig.currentLocationError }}
        </div>
        <div class="rp-dialog-footer pb-3 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              (editLocationMode === 2 && towns && isRegistTown()) ||
                editTmMode === 2
            "
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="regist"
          >
            <v-icon left>add_box</v-icon>
            {{ text.register }}
          </v-btn>
          <v-btn
            v-if="editLocationMode === 1"
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="registCurrentLocation()"
          >
            <v-icon left>my_location</v-icon>
            {{ text.currentLocation }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="cancel"
          >
            <v-icon left>clear</v-icon>
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- 確認ダイアログ -->
    <v-col v-if="riskFlg === 1" class="rp-dialog-content">
      <v-card class="ma-2 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div v-if="continuation === 2" class="rp-dialog-box pl-4 pr-2 my-2">
          {{ text.continuationMsg1 }}
          <br />
          {{ text.continuationMsg2 }}
        </div>
        <div v-else class="rp-dialog-box pl-4 pr-2 my-2">
          {{ text.confirmInfoMsg1 }}
          <br />
          {{ text.confirmInfoMsg2 }}
        </div>
        <div class="rp-dialog-footer pb-1 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="confirm"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirm }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="cancelConfirm"
          >
            <v-icon left>clear</v-icon>
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-col>

    <!-- 削除確認ダイアログ -->
    <v-col v-if="deleteFlg === 1" class="rp-dialog-content">
      <v-card class="ma-2 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.pointRegistration }}</span>
        </div>

        <div class="rp-dialog-box pl-4 pr-2 my-2">
          {{ text.deleteInfoMsg }}
        </div>
        <div class="rp-dialog-footer pb-1 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="confirmDelete"
          >
            <v-icon left>cancel</v-icon>
            {{ text.delete }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="cancelDelete"
          >
            <v-icon left>clear</v-icon>
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- 時間がかかる旨の表示ダイアログ -->
    <v-col v-if="isInfo" class="rp-dialog-content">
      <v-card class="ma-2 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="rp-dialog-box pl-4 pr-2 my-2">
          {{ text.registInfoMsg1 }}
          <br />
          {{ text.registInfoMsg2 }}
        </div>

        <div class="rp-dialog-footer pb-1 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="isInfo = false"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirmInfo }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
    <!-- プログレスダイアログ -->
    <v-col
      v-if="
        riskFlg === 2 &&
          this.editFlag !== 0 &&
          this.editLocationMode !== 1 &&
          !isInfo
      "
      class="rp-dialog-content"
    >
      <v-card class="ma-4 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="rp-dialog-box rp-dialog-box-progress pl-4 mt-2">
          <span v-if="!registPointErrMsg">{{ text.progressMsg }}</span>
          <span class="pr-2" v-else>{{ registPointErrMsg }}</span>
          <div class="rp-td-item-loading">
            <v-spacer></v-spacer>
            <v-progress-linear
              :value="progressValue"
              height="25"
              color="orange lighten-2"
              class="px-4"
            >
              {{ progressValue }}%</v-progress-linear
            >
          </div>
          <div class="rp-td-item-cancel mt-2">
            <v-spacer></v-spacer>
            <v-btn
              class="mr-4"
              small
              outlined
              color="success"
              @click="registCancel()"
              ><v-icon left>clear</v-icon>{{ text.cancel }}</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-col>
    <!-- リスク判定時のメッセージ表示ダイアログ -->
    <v-col v-if="!isInfo && registPointMsg" class="rp-dialog-content">
      <v-card class="ma-2 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.progressMsg }}</span>
        </div>
        <div class="rp-dialog-box pl-4 pr-2 my-2">
          {{ registPointMsg }}
        </div>

        <div class="rp-dialog-footer pb-1 pr-4 mb-0">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4 mb-0"
            @click="clearMsg"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirmInfo }}
          </v-btn>
        </div>
      </v-card>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 河川予警報一覧ダイアログ
 * RegistPointDlg.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import RpPoint from "../../components/rp/RpPoint.vue";
import WebStorage from "./../../lib/webStorage.js";
import mapUtil from "./../../lib/mapUtil.js";
import geodesic from "./../../lib/geodesic.js";
import PageLog from "./../../lib/pageLog.js";

export default {
  /** タグ名 */
  name: "rp-dlg",
  mixins: [mixin],
  components: {
    RpPoint,
  },
  data() {
    return {
      isFull: false,
      continuation: 0,
      tabIndex: 0,
      twnCd: "",
      townsAdd: [],
      centerTwn: {},
      isInfo: false,
      isRegist: false,
      isConfirm: false,
      text: {
        title: "地点登録",
        pointRegistration: "地点登録",
        initialDisplay: "初期表示",
        rtn: "戻る",
        selectPointMsg: "地図上で、地点登録したい位置を選択して下さい。",
        confirmPointMsg: "選択された地点を登録します。よろしいですか？",
        registErrMsg: "選択された地点は登録可能な市町村が存在しません。",
        selectObMsg: "地図上で、登録したい観測所を選択して下さい。",
        confirmObMsg: "選択された観測所を登録します。よろしいですか？",
        confirmInfoMsg1: "登録した地点のリスク判定を行います。",
        confirmInfoMsg2: "リスク判定は、最大５分程度かかる場合があります。",
        continuationMsg1: "地点を登録しました。",
        continuationMsg2:
          "続けて、登録した地点のリスク判定を行いますか？（最大5分程度かかる場合があります。）",
        registInfoMsg1:
          "リスク判定は、周辺の川が氾濫した場合の浸水想定を計算します。",
        registInfoMsg2:
          "この画面を閉じなければ、他画面を操作していてもリスク判定を進めることができます。",
        deleteInfoMsg: "登録地点を削除しますか？",
        progressMsg: "リスク判定",
        pointName: "地点",
        register: "登録",
        confirmInfo: "確認",
        confirm: "判定実行",
        delete: "削除",
        cancel: "キャンセル",
        currentLocation: "現在位置登録",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[RegistPointDlg] mounted()");

    this.$store.commit("app/setContent", "VcPoint");

    // 初期表示時に有効データの一番上を選択
    let point1 = WebStorage.getPoint1Info();
    let point2 = WebStorage.getPoint2Info();
    let point3 = WebStorage.getPoint3Info();
    let point4 = WebStorage.getPoint4Info();
    let point5 = WebStorage.getPoint5Info();
    let index = 0;
    if (point1) {
      index = 0;
    } else if (point2) {
      index = 1;
    } else if (point3) {
      index = 2;
    } else if (point4) {
      index = 3;
    } else if (point5) {
      index = 4;
    }
    this.$store.commit("viewConfig/setSelectedPoint", index);
  },
  computed: {
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** タブ選択値 */
    selectedIndex: {
      get() {
        return this.tabIndex;
      },
    },
    /** 登録地編集モード */
    editLocationMode: {
      get() {
        return this.$store.state.map.editLocationMode;
      },
    },
    /** 登録地点選択座標 */
    editLocation: {
      get() {
        return this.$store.state.map.editLocation;
      },
    },
    /** 周辺観測所編集モード */
    editTmMode: {
      get() {
        return this.$store.state.map.editTmMode;
      },
    },
    /** 周辺観測所 */
    editTm: {
      get() {
        return this.$store.state.map.editTm;
      },
    },
    /** 地点登録 選択テレメータ情報 */
    tmSelectedPointData: {
      get() {
        return this.$store.state.Telemeter.tmSelectedPointData;
      },
    },
    /** 地点登録 選択危機管理型水位計情報 */
    swSelectedPointData: {
      get() {
        return this.$store.state.Swin.swSelectedPointData;
      },
    },
    /** 地点登録 選択危機カメラ情報 */
    swSelectedPointCctvData: {
      get() {
        return this.$store.state.Swin.swSelectedPointCctvData;
      },
    },
    /** 地点登録 選択簡易カメラ情報 */
    swSelectedPointScamData: {
      get() {
        return this.$store.state.Swin.swSelectedPointScamData;
      },
    },
    /** 登録地点読み込み日時 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 範囲内の市町村 */
    towns: {
      get() {
        return this.$store.state.viewConfig.towns;
      },
    },
    /** 登録中フラグ */
    editFlag: {
      get() {
        return this.$store.state.map.editFlag;
      },
    },
    /** 選択地点名 */
    selectedPointName: {
      get() {
        return this.$store.state.viewConfig.selectedPointName;
      },
    },
    /** 選択地点インデックス（初期表示設定用） */
    selectedPointIndex: {
      get() {
        return this.$store.state.viewConfig.selectedPoint;
      },
    },
    /** メッセージ情報 */
    messageConfig: {
      get() {
        return this.$store.state.app.config.messageConfig;
      },
    },
    /** 現在位置登録エラーフラグ */
    registCurrentLocationErrorFlag: {
      get() {
        return this.$store.state.map.registCurrentLocationErrorFlag;
      },
    },
    /** 現在位置登録フラグ */
    registCurrentLocationFlag: {
      get() {
        return this.$store.state.map.registCurrentLocationFlag;
      },
    },
    /** リスク収集フラグ */
    riskFlg: {
      get() {
        return this.$store.state.viewConfig.riskFlg;
      },
    },
    /** 削除フラグ */
    deleteFlg: {
      get() {
        return this.$store.state.viewConfig.deleteFlg;
      },
    },
    /** プログレスの値 */
    progressValue: {
      get() {
        let val = (this.$store.state.Telemeter.registPointState / 4) * 100;
        return val;
      },
    },
    /** 地点登録エラーメッセージ */
    registPointErrMsg: {
      get() {
        return this.$store.state.Telemeter.registPointErrMsg;
      },
    },
    /** 地点登録メッセージ */
    registPointMsg: {
      get() {
        return this.$store.state.Telemeter.registPointMsg;
      },
    },
  },
  /** メソッド */
  methods: {
    /** 画面拡大 */
    expansionWindow() {
      this.$log.debug("[RegistPointDlg] expansionWindow()");
      var dlg = document.getElementById("rp-dialog");
      dlg.className = "com-mb-dialog large v-card v-sheet theme--light";
      this.isFull = true;
    },
    /** 画面縮小 */
    reductionWindow() {
      this.$log.debug("[RegistPointDlg] reductionWindow()");
      var dlg = document.getElementById("rp-dialog");
      dlg.className = "com-mb-dialog normal v-card v-sheet theme--light";
      this.isFull = false;
    },
    /** 画面を閉じる */
    closeDlg() {
      this.$log.debug("[RegistPointDlg] closeDlg()");
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    },
    /** 戻るボタンクリック */
    clickReturn() {
      this.$log.debug("[RegistPointDlg] clickReturn()");
      this.$store.commit("app/setContent", "VcDefault");
    },
    /** キャンセル */
    cancel() {
      this.$log.debug("[RegistPointDlg] cancel()");
      this.$store.commit("map/setEditLocationMode", 0);
      this.$store.commit("map/setEditTmMode", 0);
      this.$store.commit("map/setEditFlag", 0);
    },
    /** 登録 */
    regist() {
      this.$log.debug("[RegistPointDlg] regist()");
      if (this.editLocationMode === 2) {
        this.$log.debug("[RegistPointDlg] regist editLocationMode == 2");
        // ボタンを登録中で表示
        this.$store.commit("map/setEditFlag", 1);
        // 地点選択時
        var points = [
          {
            lat: this.$store.state.map.editLocation.latlng[0],
            lng: this.$store.state.map.editLocation.latlng[1],
          },
        ];

        let targetTwn = {};
        for (let town of this.towns) {
          if (town.twnCd === this.twnCd) {
            targetTwn = town;
            targetTwn.townNm = targetTwn.twnNm;
            targetTwn.townCd = targetTwn.twnCd;
            break;
          }
        }

        var riverInfo = { sys: "ph2" };
        geodesic.getPointEl(points, riverInfo, (self) => {
          var centerHeight = null;
          if (self.pointsData != null && self.pointsData.length > 0) {
            centerHeight = Math.round(self.pointsData[0].h * 100) / 100;
          }
          let pointInfo = {
            pointIndex: this.$store.state.viewConfig.selectedPoint,
            name: this.$store.state.viewConfig.selectedPointName,
            center: this.$store.state.map.editLocation.latlng,
            centerHeight: centerHeight,
            twnCd: targetTwn.townCd,
            prefCd: targetTwn.prefCd,
            address: targetTwn.prefNm + targetTwn.townNm,
            risk: false,
            luDatas: [],
            tmDatas: {
              tmPoint: [],
              swPoint: [],
              scamPoint: [],
            },
            bpDatas: [],
            zoom: this.$store.state.map.editLocation.zoom,
          };
          this.$store.commit("Telemeter/setTmPointDatas", pointInfo);
          this.$store.commit("map/setEditLocationMode", 0);
        });

        // 確認ダイアログ
        this.isConfirm = true;
        // 継続チェック判定を設定
        this.continuation = 1;
      }
    },
    /** 確認 */
    confirm() {
      this.$log.debug("[RegistPointDlg] confirm()");
      let index = this.$store.state.viewConfig.selectedPoint;
      let point;

      // webストレージから表示情報を取得
      if (index === 0) {
        point = WebStorage.getPoint1Info();
      } else if (index === 1) {
        point = WebStorage.getPoint2Info();
      } else if (index === 2) {
        point = WebStorage.getPoint3Info();
      } else if (index === 3) {
        point = WebStorage.getPoint4Info();
      } else if (index === 4) {
        point = WebStorage.getPoint5Info();
      }

      let centerTwn = {
        townCd: point.twnCd,
        prefCd: point.prefCd,
        address: point.address,
      };
      let maxmin = this.getTownNameRange(point.center);

      // リスク判定を行う
      this.$store.dispatch("Telemeter/getTmDatasByPoint", {
        pointIndex: index,
        name: point.name,
        center: point.center,
        centerTwn: centerTwn,
        centerHeight: point.centerHeight,
        minLatLon: maxmin.minCoord,
        maxLatLon: maxmin.maxCoord,
        zoom: point.zoom,
        token: this.$store.state.app.token,
        iconImg: point.iconImg,
        iconSize: point.iconSize,
      });

      this.$store.commit("map/setEditFlag", 1);
      this.$store.commit("viewConfig/setRiskFlg", 2);
      this.isInfo = true;
      // 確認状態のクリア
      this.continuation = 0;
    },
    /** キャンセル */
    cancelConfirm() {
      this.$log.debug("[RegistPointDlg] cancelConfirm()");
      this.continuation = 0;
      this.$store.commit("viewConfig/setRiskFlg", 0);
    },
    /** 削除確認確認 */
    confirmDelete() {
      this.$log.debug("[RegistPointDlg] confirmDelete()");

      let index = this.$store.state.viewConfig.selectedPoint;
      let point = "";
      let defaultInfo = WebStorage.getDefaultInfo();
      switch (index) {
        case 0:
          this.$log.debug("[RegistPointDlg] confirmDelete index == 0");
          WebStorage.setPoint1Info(point);
          if (defaultInfo.point1) {
            defaultInfo.point1 = false;
          }
          break;
        case 1:
          this.$log.debug("[RegistPointDlg] confirmDelete index == 1");
          WebStorage.setPoint2Info(point);
          if (defaultInfo.point2) {
            defaultInfo.point2 = false;
          }
          break;
        case 2:
          this.$log.debug("[RegistPointDlg] confirmDelete index == 2");
          WebStorage.setPoint3Info(point);
          if (defaultInfo.point3) {
            defaultInfo.point3 = false;
          }
          break;
        case 3:
          this.$log.debug("[RegistPointDlg] confirmDelete index == 3");
          WebStorage.setPoint4Info(point);
          if (defaultInfo.point4) {
            defaultInfo.point4 = false;
          }
          break;
        case 4:
          this.$log.debug("[RegistPointDlg] confirmDelete index == 4");
          WebStorage.setPoint5Info(point);
          if (defaultInfo.point5) {
            defaultInfo.point5 = false;
          }
          break;
      }
      defaultInfo.pointDefault = true;
      WebStorage.setDefaultInfo(defaultInfo);

      // 地点の削除
      this.$store.dispatch("Telemeter/deletePoint", {
        pointNo: index + 1,
        token: this.$store.state.app.token,
      });

      // 削除フラグをクリア
      this.$store.commit("viewConfig/setDeleteFlg", 0);
      // 選択値クリア
      this.$store.commit("viewConfig/setSelectedPoint", "");
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 削除キャンセル */
    cancelDelete() {
      this.$log.debug("[RegistPointDlg] cancelDelete()");
      this.$store.commit("viewConfig/setDeleteFlg", 0);
    },
    /** 登録完了確認 */
    registFinish() {
      this.$log.debug("[RegistPointDlg] registFinish()");
      this.isRegist = false;
    },
    /** 登録市町村有無 */
    isRegistTown() {
      if (this.towns) {
        for (let town of this.towns) {
          if (town.twnCd) {
            return true;
          }
        }
      }
      return false;
    },
    /** 初期表示設定 */
    editDefault() {
      this.$log.debug("[RegistPointDlg] editDefault");
      // webストレージから取得
      let info = WebStorage.getDefaultInfo();
      let point1 = WebStorage.getPoint1Info();
      let point2 = WebStorage.getPoint2Info();
      let point3 = WebStorage.getPoint3Info();
      let point4 = WebStorage.getPoint4Info();
      let point5 = WebStorage.getPoint5Info();
      if (point1 && this.selectedPointIndex === 0) {
        info.point1 = true;
        info.point2 = false;
        info.point3 = false;
        info.point4 = false;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point2 && this.selectedPointIndex === 1) {
        info.point1 = false;
        info.point2 = true;
        info.point3 = false;
        info.point4 = false;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point3 && this.selectedPointIndex === 2) {
        info.point1 = false;
        info.point2 = false;
        info.point3 = true;
        info.point4 = false;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point4 && this.selectedPointIndex === 3) {
        info.point1 = false;
        info.point2 = false;
        info.point3 = false;
        info.point4 = true;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point5 && this.selectedPointIndex === 4) {
        info.point1 = false;
        info.point2 = false;
        info.point3 = false;
        info.point4 = false;
        info.point5 = true;
        info.pointDefault = false;
      }
      // webストレージ書き込み
      WebStorage.setDefaultInfo(info);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 現在位置取得・移動 */
    moveCurrentLocation() {
      if (!this.$store.state.map.currentLocationFlag) {
        // アクセスログ出力
        PageLog.log({
          page_log: "gps",
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
      this.$store.dispatch("map/moveCurrentLocation", "pc");
    },
    /** 現在位置登録 */
    registCurrentLocation() {
      this.$log.debug("[RegistPointDlg] registCurrentLocation()");
      this.$store.dispatch("map/registCurrentLocation");
    },
    /** 登録キャンセル */
    registCancel() {
      this.$log.debug("[RegistPointDlg] registCancel()");

      // ステータスをクリア
      this.$store.commit("map/setEditLocationMode", 0);
      this.$store.commit("map/setEditTmMode", 0);
      this.$store.commit("map/setEditFlag", 0);

      // 地点登録状況に9:キャンセルを設定
      this.$store.commit("Telemeter/setRegistPointState", 9);
    },
    /** 地点登録メッセージのクリア */
    clearMsg() {
      this.$store.commit("Telemeter/setRegistPointMsg", "");
    },
  },
  watch: {
    /**
     * タブ選択値変更時
     */
    selectedIndex() {
      this.$log.debug("[RegistPointDlg] watch(selectedIndex)");
      if (this.tabIndex === 0) {
        this.$store.commit("app/setContent", "VcPoint");
      } else if (this.tabIndex === 1) {
        this.$store.commit("app/setContent", "VcDefault");
      }
    },
    /** 登録地点選択座標変更時 */
    editLocation() {
      this.$log.debug("[RegistPointDlg] watch(editLocation)");
      this.$store.commit("map/setEditLocationMode", 2);
    },
    /** 周辺観測所変更時 */
    editTm() {
      this.$log.debug("[RegistPointDlg] watch(editTm)");
      this.$store.commit("map/setEditTmMode", 2);
    },
    /** 地点登録 選択テレメータ情報変更時 */
    tmSelectedPointData() {
      this.$log.debug("[RegistPointDlg] watch(tmSelectedPointData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }

      if (this.tmSelectedPointData.cctvCd) {
        this.$log.debug("[RegistPointDlg] watch(tmSelectedPointData) cctv");
        // CCTVの場合
        let cctvInfo = {
          ofcCd: this.tmSelectedPointData.ofcCd,
          cctvCd: this.tmSelectedPointData.cctvCd,
          cctvNm: this.tmSelectedPointData.cctvNm,
          riverName: this.tmSelectedPointData.riverName,
          lat: this.tmSelectedPointData.lat,
          lon: this.tmSelectedPointData.lon,
          twnCd: this.tmSelectedPointData.twnCd,
          distance: this.tmSelectedPointData.distance,
          notice: true,
        };
        point.tmDatas.cctvPoint.push(cctvInfo);
      } else {
        this.$log.debug("[RegistPointDlg] watch(tmSelectedPointData) tm");
        // テレメータの場合
        let tmInfo = {
          ofcCd: this.tmSelectedPointData.ofcCd,
          itmkndCd: this.tmSelectedPointData.itmkndCd,
          obsCd: this.tmSelectedPointData.obsCd,
          name: this.tmSelectedPointData.name,
          riverName: this.tmSelectedPointData.riverName,
          lat: this.tmSelectedPointData.lat,
          lon: this.tmSelectedPointData.lon,
          twnCd: this.tmSelectedPointData.twnCd,
          distance: this.tmSelectedPointData.distance,
          notice: true,
        };
        point.tmDatas.tmPoint.push(tmInfo);

        // 通知情報の変更をDBに反映
        this.$store.dispatch("Telemeter/changeNotice", {
          pointNo: this.$store.state.viewConfig.selectedPoint,
          token: this.$store.state.app.token,
          selectedPoint: point,
        });
      }

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 地点登録 選択危機管理型水位計情報 */
    swSelectedPointData() {
      this.$log.debug("[RegistPointDlg] watch(swSelectedPointData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }
      let swInfo = {
        swobsCd: this.swSelectedPointData.swobsCd,
        swobsNm: this.swSelectedPointData.swobsNm,
        swrvrCd: this.swSelectedPointData.swrvrCd,
        swrvrNm: this.swSelectedPointData.swrvrNm,
        lat: this.swSelectedPointData.lat,
        lon: this.swSelectedPointData.lon,
        twnCd: this.swSelectedPointData.twnCd,
        distance: this.swSelectedPointData.distance,
        notice: true,
      };
      point.tmDatas.swPoint.push(swInfo);

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // 通知情報の変更をDBに反映
      this.$store.dispatch("Telemeter/changeNotice", {
        pointNo: this.$store.state.viewConfig.selectedPoint,
        token: this.$store.state.app.token,
        selectedPoint: point,
      });

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 地点登録 選択簡易カメラ情報 */
    swSelectedPointScamData() {
      this.$log.debug("[RegistPointDlg] watch(swSelectedPointScamData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }
      let scamInfo = {
        scamId: this.swSelectedPointScamData.scamId,
        name: this.swSelectedPointScamData.camsName,
        rvrCd: this.swSelectedPointScamData.rvrCd,
        rvrNm: this.swSelectedPointScamData.rvrName,
        lat: this.swSelectedPointScamData.lat,
        lon: this.swSelectedPointScamData.lon,
        twnCd: this.swSelectedPointScamData.twnCd,
        distance: this.swSelectedPointScamData.distance,
        notice: true,
      };
      point.tmDatas.scamPoint.push(scamInfo);

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointScamData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 地点登録 選択危機カメラ情報 */
    swSelectedPointCctvData() {
      this.$log.debug("[RegistPointDlg] watch(swSelectedPointCctvData)");
      // 観測所選択時
      let point;
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointCctvData) getPoint1Info"
          );
          point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointCctvData) getPoint2Info"
          );
          point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointCctvData) getPoint3Info"
          );
          point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointCctvData) getPoint4Info"
          );
          point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(swSelectedPointCctvData) getPoint5Info"
          );
          point = WebStorage.getPoint5Info();
          break;
      }
      let swcctvInfo = {
        swcctvCd: this.swSelectedPointCctvData.swcctvCd,
        swcctvNm: this.swSelectedPointCctvData.swcctvNm,
        swrvrCd: this.swSelectedPointCctvData.swrvrCd,
        swrvrNm: this.swSelectedPointCctvData.swrvrNm,
        lat: this.swSelectedPointCctvData.lat,
        lon: this.swSelectedPointCctvData.lon,
        twnCd: this.swSelectedPointCctvData.twnCd,
        distance: this.swSelectedPointCctvData.distance,
        notice: true,
      };
      point.tmDatas.swcctvPoint.push(swcctvInfo);

      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint1Info"
          );
          WebStorage.setPoint1Info(point);
          break;
        case 1:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint2Info"
          );
          WebStorage.setPoint2Info(point);
          break;
        case 2:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint3Info"
          );
          WebStorage.setPoint3Info(point);
          break;
        case 3:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint4Info"
          );
          WebStorage.setPoint4Info(point);
          break;
        case 4:
          this.$log.debug(
            "[RegistPointDlg] watch(tmSelectedPointData) setPoint5Info"
          );
          WebStorage.setPoint5Info(point);
          break;
      }

      // モードを更新
      this.$store.commit("map/setEditTmMode", 0);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 登録地編集モード */
    editLocationMode() {
      this.$log.debug("[RegistPointDlg] watch(editLocationMode)");
      if (this.editLocationMode === 2) {
        let centerTwn = mapUtil.getNearTown(
          this.$store.state.map.editLocation.latlng,
          this.$store.state.map.latLngListByPref,
          this.$store.state.map.prefs
        );
        this.twnCd = centerTwn.townCd;
        this.centerTwn = centerTwn;

        let latlonList = geodesic.getBounds(
          this.$store.state.map.editLocation.latlng,
          this.$store.state.app.config.registConfig.townDistance
        );
        this.$store.dispatch("viewConfig/getTwns", {
          minlat: latlonList.minCoord[0],
          minlon: latlonList.minCoord[1],
          maxlat: latlonList.maxCoord[0],
          maxlon: latlonList.maxCoord[1],
        });
      } else if (this.editLocationMode === 0) {
        if (this.continuation === 1) {
          // 地点登録後にリスク判定を続行
          this.continuation = 2;
          // 確認ダイアログを表示
          this.$store.commit("viewConfig/setRiskFlg", 1);
        }
      }
    },
    /** 地図の登録地点が読み直された場合、コンポーネントも再表示 */
    editWebStorageDate() {
      this.$log.debug("[RegistPointDlg] watch(editWebStorageDate)");
      this.$store.commit("map/setEditFlag", 0);
    },
    /** 市町村リスト */
    towns() {
      this.$log.debug("[RegistPointDlg] watch(towns)");
      // 現在位置登録時は、市町村コードを設定
      if (this.registCurrentLocationFlag) {
        let centerTwn = mapUtil.getNearTown(
          this.$store.state.map.editLocation.latlng,
          this.$store.state.map.latLngListByPref,
          this.$store.state.map.prefs
        );
        this.twnCd = centerTwn.townCd;
        this.centerTwn = centerTwn;
      }
      // 選択した地点の市町村が、市町村のラジオに存在しない場合は追加する
      let isTwn = false;
      for (let town of this.towns) {
        if (town.twnCd === this.centerTwn.townCd) {
          isTwn = true;
        }
      }
      this.townsAdd = [];
      if (!isTwn && this.towns.length > 0) {
        this.townsAdd.push({
          twnCd: this.centerTwn.townCd,
          prefNm: this.centerTwn.prefNm,
          twnNm: this.centerTwn.townNm,
        });
      }
    },
    /** 登録中フラグ */
    editFlag() {
      this.$log.debug("[RegistPointDlg] watch(editFlag)");
      if (this.editFlag === 0) {
        this.isRegist = true;
        this.editDefault();
      }
    },
    /** 選択地点番号 */
    selectedPoint() {
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.point = WebStorage.getPoint1Info();
          break;
        case 1:
          this.point = WebStorage.getPoint2Info();
          break;
        case 2:
          this.point = WebStorage.getPoint3Info();
          break;
        case 3:
          this.point = WebStorage.getPoint4Info();
          break;
        case 4:
          this.point = WebStorage.getPoint5Info();
          break;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/_media_query.scss";
@import "./../../scss/color.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 70%;
    top: 84px;
  }
  .large {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 60%;
    bottom: 4px;
  }
  .large {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
  .small {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 170px;
    bottom: 4px;
  }
}

#rp-dialog {
  right: 4px;
  .rp-tab {
    display: flex;
    flex-direction: row;
    margin: 0;
    height: 45px;
    .rp-tab-btn {
      margin: 0;
      width: 100px;
    }
  }
}

.rp-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
}

.rp-dialog-content {
  position: absolute;
  background-color: rgba(lightgray, 0.8);
  z-index: 3190;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  bottom: 0px;
  right: 0px;

  .rp-dialog-card {
    height: 90%;
    display: flex;
    flex-direction: column;
    .rp-header {
      display: flex;
    }
    .rp-dialog-header {
      background-color: $color-header-back;
      color: $color-header-text;
      line-height: 40px;
      height: 40px;
      width: 100%;
    }

    .rp-dialog-box {
      // flex: 1;
      height: calc(100% - 80px);
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      overflow-y: auto;

      .rp-radio-box {
        flex: 1;
        overflow-y: auto;
      }
    }

    .rp-dialog-box-progress {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      .rp-td-item-loading {
        display: flex;
        justify-content: flex-end;
        width: calc(100% - 20px);
      }
      .rp-td-item-cancel {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        width: 100%;
      }
    }

    .rp-dialog-footer {
      height: 40px;
    }
    .get-location-error-message {
      color: $color-error-message;
    }
  }

  .rp-dialog-card-regist {
    height: 160px;
  }
}

.rp-dialog-content-confirm {
  height: 200px;
}

.rp-btn-item {
  justify-content: center;
  font-size: 0.55rem;

  .rp-btn-image {
    height: 20px;
  }
}
</style>
